import { render, staticRenderFns } from "./ScreeningDataInfo.vue?vue&type=template&id=60c7a82c&scoped=true"
import script from "./ScreeningDataInfo.vue?vue&type=script&lang=js"
export * from "./ScreeningDataInfo.vue?vue&type=script&lang=js"
import style0 from "./ScreeningDataInfo.vue?vue&type=style&index=0&id=60c7a82c&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7a82c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c7a82c')) {
      api.createRecord('60c7a82c', component.options)
    } else {
      api.reload('60c7a82c', component.options)
    }
    module.hot.accept("./ScreeningDataInfo.vue?vue&type=template&id=60c7a82c&scoped=true", function () {
      api.rerender('60c7a82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screening/screeningDataInfo/ScreeningDataInfo.vue"
export default component.exports